import React from 'react';
import { useLocation } from 'wouter';
import { Box, Stack } from '@mui/material';
import MyContainer from '@/components/MyContainer';
import { SaveButton } from '@/components/ui/buttons/save-button';
import { Button } from '@/components/ui/button';
import { useCreateUser } from '@/services/user-service';
import type { UserFormValues } from '@/api/types';
import { UserForm } from '@/components/users/user-form';
import { useUserForm } from './hooks/use-user-form';

export default function CreateUserPage() {
  const [, setLocation] = useLocation();
  const createUserMutation = useCreateUser();

  const { form, handleSave } = useUserForm({
    mode: 'create',
  });

  const handleSubmit = async (values: UserFormValues) => {
    const response = await createUserMutation.execute(values);
    if (!response.success || !response.data) {
      throw new Error(response.message || 'Failed to create user');
    }

    return response.data;
  };

  const handleSuccess = () => {
    setLocation('/users');
  };

  const handleCancel = () => {
    setLocation('/users');
  };

  return (
    <MyContainer
      title="Create user"
      subtitle="Add a new user to your system."
      actions={<SaveButton disabled={form.formState.isSubmitting} handleSave={handleSave} />}
      footer={
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Stack direction="row" spacing={1}>
            <Button variant="outline" size="sm" onClick={handleCancel}>
              Cancel
            </Button>
            <SaveButton disabled={form.formState.isSubmitting} handleSave={handleSave} />
          </Stack>
        </Box>
      }
    >
      <UserForm
        form={form}
        mode="create"
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </MyContainer>
  );
}
